import imageUrlBuilder from '@sanity/image-url';

const builder = imageUrlBuilder({
    projectId: import.meta.env.VITE_SANITY_PROJECT_ID,
    dataset: import.meta.env.VITE_SANITY_DATASET,
});

type ImageSource = {
    asset : {_ref: string, _type: string }
    hero_image_alternative_text : string
    _type : "image"
}

export const sanityImage = (source : ImageSource) => {
    return builder.image(source)
}

export default sanityImage;